import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import TableOperation from '../../Elements/Table/tableOperation'
import FilterOperation from './filterTransferOperation'

class Operation extends Component 
{
    render()
    {
        const {data} = this.props.res;
        const res = this.props.res;
        return(
            <Paper className="operationBox">
                <FilterOperation
                 asyncDisabled={this.props.asyncDisabled}
                 startDate={this.props.startDate}
                 endDate={this.props.endDate}
                 onSubsmit={this.props.onSubsmit} 
                 res={res} className="FilterOperationBox"
                 selectPeriod={this.props.selectPeriod}
                 selectPointofSale={this.props.selectPointofSale}
                 selectCard={this.props.selectCard}
                 setstartDate={this.props.setstartDate}
                 setendDate={this.props.setendDate}
                 period={this.props.period}
                 ></FilterOperation>
                <TableOperation 
                page={this.props.page}
                asyncDisabled={this.props.asyncDisabled}
                data={data} 
                className="operationTable"
                setPage={this.props.setPage}
                setLimit={this.props.setLimit}
                limit={this.props.limit}
                ></TableOperation>
            </Paper>
        );
    }
}

export default Operation;